import { makeStyles } from '@material-ui/core/styles';

const styles = () => ({
  dialogContainer: {
    width: '512px',
    overflow: 'hidden',
    borderRadius: '8px',
  },

  content: {
    padding: '33px 36px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '16px',
  },

  textbox: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3px',
  },

  successTitle: {
    marginTop: '8px',
    fontWeight: 600,
    textAlign: 'center',
  },

  okButton: {
    backgroundColor: '#76BD22',
    width: '96px',
    height: '43px',
    fontSize: '16px',
    marginTop: '10px',
    '&:hover': {
      backgroundColor: '#76BD22',
    },
  },
});

export default styles;
export const useStyles = makeStyles(styles);
